/* RRM 2026-10-03 (Mason). Drawer behaviour the theme does not ship: the
   discount code apply, the delivery line under the subtotal, the Signing
   Pack code pre-fill. Everything else (open, close, Escape, focus trap,
   scroll lock, rebuilds) stays Impulse's.
   2026-10-18: recommendations in the bag (Deme: "cart recommendations
   upsell similar to UpCart"). Shopify's Product Recommendations API for the
   first two line items (complementary, falling back to related), the
   Complete-the-set partner pinned first (handle comes from
   templates/cart.ajax.liquid), nothing already in the bag, nothing sold
   out, deduped. Quick add: one variant adds straight away, one size option
   shows inline size cells (sold-out cells disabled), two options (sets)
   link to the product page. The old one-tap Complete-the-set row that added
   the first available size blind is gone. Free-delivery threshold comes from
   a theme setting via a data attribute (0 = no free-delivery logic at all).
   2026-10-18b: the drawer's recs box lives INSIDE the scraped .cart__items
   (right under the line items, a horizontal swipe row) so every scrape
   replaces it; cached candidates re-render on each mutation. The delivery
   line moved into the Liquid summary well, the JS no longer writes it. */
(function () {
  'use strict';
  if (window.__rrmCartBound) return;
  window.__rrmCartBound = true;

  function rebuild() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  function applyCode(input) {
    var code = (input.value || '').trim();
    if (!code) return;
    var btn = document.querySelector('[data-rrm-code-apply]');
    if (btn) btn.textContent = '...';
    /* GET /discount/CODE stores the code (and applies it to the cart on
       stores with cart-level code support), returning to the current page. */
    fetch('/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(window.location.pathname))
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        rebuild();
        if (!(cart.total_discount > 0) && btn) {
          btn.textContent = 'Apply';
          input.setAttribute('placeholder', 'Code saved for checkout');
          input.value = '';
        }
      })
      .catch(function () { if (btn) btn.textContent = 'Apply'; });
  }

  /* ---------- config from the theme (data attributes, never hardcoded) */
  function cfgEl() {
    return document.querySelector('[data-rrm-free]');
  }
  function freeAt() {
    var el = cfgEl();
    var n = el ? parseInt(el.dataset.rrmFree, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (err) { /* fall through */ }
    return '£' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });
  }

  /* ---------- recommendations */
  var recs = { sig: null, cands: null, busy: false };

  function recBoxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-rrm-recs]'))
      .filter(function (b) { return !b.closest('#CartPageForm'); });
  }
  var lastCart = null;
  function drawerOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.classList.contains('drawer--is-open'));
  }
  function onCartPage() {
    return !!document.querySelector('.rrm-recs--page');
  }

  function recsFor(pid) {
    var base = '/recommendations/products.json?product_id=' + pid + '&limit=8&intent=';
    return getJSON(base + 'complementary').then(function (d) {
      if (d.products && d.products.length) return d.products;
      return getJSON(base + 'related').then(function (d2) { return d2.products || []; });
    }).catch(function () { return []; });
  }

  function loadRecs(force) {
    var boxes = recBoxes();
    if (!boxes.length) return;
    if (!force && !drawerOpen() && !onCartPage()) return;
    if (recs.busy) return;
    recs.busy = true;
    getJSON('/cart.js').then(function (cart) {
      if (!cart.item_count) {
        recs.sig = null; recs.cands = null;
        boxes.forEach(function (b) { b.hidden = true; b.innerHTML = ''; });
        recs.busy = false;
        return;
      }
      lastCart = cart;
      var pids = cart.items.map(function (i) { return i.product_id; });
      var partnerEl = document.querySelector('[data-rrm-partner]');
      var partner = partnerEl ? partnerEl.dataset.rrmPartner : '';
      var sig = pids.slice().sort().join(',') + '|' + partner + '|' + (cart.currency || '');
      if (sig === recs.sig && recs.cands) {
        render(recs.cands, cart);
        recs.busy = false;
        return;
      }
      var reqs = pids.slice(0, 2).map(recsFor);
      if (partner) {
        reqs.unshift(getJSON('/products/' + partner + '.js').then(function (p) {
          p._partner = true; return [p];
        }).catch(function () { return []; }));
      }
      Promise.all(reqs).then(function (lists) {
        var seen = {}, cands = [];
        lists.forEach(function (list) {
          list.forEach(function (p) {
            if (!p || seen[p.id] || pids.indexOf(p.id) > -1 || !p.available) return;
            seen[p.id] = 1;
            cands.push(p);
          });
        });
        recs.sig = sig; recs.cands = cands;
        render(cands, cart);
        recs.busy = false;
      }).catch(function () { recs.busy = false; });
    }).catch(function () { recs.busy = false; });
  }

  function render(cands, cart) {
    var free = freeAt();
    var gap = free > 0 ? free - cart.total_price : 0;
    recBoxes().forEach(function (box) {
      var n = parseInt(box.dataset.rrmCount, 10);
      if (isNaN(n)) n = 4;
      n = Math.min(4, Math.max(2, n));
      /* Order: the set partner first; then whatever lifts the bag over the
         free-delivery line, cheapest first; then Shopify's own order. */
      var partner = [], over = [], rest = [];
      cands.forEach(function (p) {
        if (p._partner) partner.push(p);
        else if (gap > 0 && p.price >= gap) over.push(p);
        else rest.push(p);
      });
      over.sort(function (a, b) { return a.price - b.price; });
      var list = partner.concat(over, rest).slice(0, n);
      if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }
      box.innerHTML = '<p class="rrm-recs-head">' + esc(box.dataset.rrmHeading || 'You may also like') + '</p>' +
        '<div class="rrm-recs-grid">' + list.map(tile).join('') + '</div>';
      box.hidden = false;
    });
  }

  function imgUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function tile(p) {
    var parts = p.title.split(' - ');
    var name = parts.length > 1 ? parts.slice(0, -1).join(' - ') : p.title;
    var colour = parts.length > 1 ? parts[parts.length - 1].trim() : '';
    var opts = (p.options || []).filter(function (o) {
      return !(o.values && o.values.length === 1 && o.values[0] === 'Default Title');
    });
    var avail = p.variants.filter(function (v) { return v.available; });
    var body;
    if (!avail.length) {
      body = '';
    } else if (opts.length === 0 || p.variants.length === 1) {
      body = '<button type="button" class="rrm-recs-add" data-rrm-rec-add="' + avail[0].id + '">Add</button>';
    } else if (opts.length === 1) {
      body = '<div class="rrm-recs-sizes" role="group" aria-label="' + esc(name) + ', choose a size">' +
        p.variants.map(function (v) {
          return '<button type="button" class="rrm-recs-sz" data-rrm-rec-add="' + v.id + '"' +
            (v.available ? '' : ' disabled aria-disabled="true"') +
            ' aria-label="' + esc(name) + ' ' + esc(v.title) + (v.available ? '' : ', sold out') + '">' +
            esc(v.title) + '</button>';
        }).join('') + '</div>';
    } else {
      /* two options (hoodie size + jogger size): pick on the product page */
      body = '<a class="rrm-recs-add rrm-recs-view" href="' + esc(p.url) + '">Select sizes</a>';
    }
    var tag = p._partner ? '<span class="rrm-recs-tag">Complete the set</span>' : '';
    var price = (p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + money(p.price);
    var img = imgUrl(p.featured_image);
    return '<div class="rrm-rec" data-rrm-rec="' + p.id + '">' +
      '<a class="rrm-rec-ph" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="300">' : '') + tag + '</a>' +
      '<div class="rrm-rec-m"><a href="' + esc(p.url) + '">' + esc(name) + '</a><span>' + price + '</span></div>' +
      (colour ? '<p class="rrm-rec-c">' + esc(colour) + '</p>' : '') +
      body + '</div>';
  }

  function quickAdd(btn) {
    var id = Number(btn.dataset.rrmRecAdd);
    if (!id) return;
    var cells = btn.closest('.rrm-rec');
    if (cells) cells.classList.add('is-busy');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }).then(function () {
      if (btn.closest('#CartDrawer')) {
        rebuild();
      } else {
        /* cart page: Impulse's CartForm rebuilds [data-products] on cart:build */
        document.dispatchEvent(new CustomEvent('cart:build'));
        loadRecs(true);
      }
    }).catch(function () {
      btn.disabled = false;
      if (cells) cells.classList.remove('is-busy');
      btn.textContent = 'Sold out';
      btn.disabled = true;
    });
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-rrm-code-apply]');
    if (apply) {
      var input = document.querySelector('[data-rrm-code]');
      if (input) applyCode(input);
      return;
    }
    var add = e.target.closest('[data-rrm-rec-add]');
    if (add && !add.disabled) quickAdd(add);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-rrm-code]')) {
      e.preventDefault(); /* Enter must not submit the cart form to checkout */
      applyCode(e.target);
    }
  });

  function refresh() {
    var items = document.querySelector('#CartDrawer .cart__items');
    var countEl = document.querySelector('[data-rrm-count]');
    if (countEl && items) countEl.textContent = parseInt(items.dataset.count, 10) || 0;

    /* Signing Pack pre-fill: the popup stores converted in benir_pack_v1
       and the snippet exposes the code on BENIR_PACK_CONFIG.reward.code. */
    var codeInput = document.querySelector('[data-rrm-code]');
    if (codeInput && !codeInput.value) {
      try {
        var st = JSON.parse(localStorage.getItem('benir_pack_v1')) || {};
        var cfg = window.BENIR_PACK_CONFIG;
        if (st.converted && cfg && cfg.reward && cfg.reward.code) {
          codeInput.value = cfg.reward.code;
        }
      } catch (err) { /* storage blocked, non-fatal */ }
    }

    /* a scrape just replaced the recs placeholder: paint the cached list
       straight back, then let loadRecs refetch if the bag changed */
    if (recs.cands && lastCart) render(recs.cands, lastCart);
    loadRecs(false);
  }

  function boot() {
    document.querySelectorAll('[data-products]').forEach(function (products) {
      new MutationObserver(refresh).observe(products, { childList: true });
    });
    document.addEventListener('cart:updated', refresh);
    /* the drawer opens on add and on the bag icon; recs load on open */
    document.addEventListener('ajaxProduct:added', function () { setTimeout(function () { loadRecs(true); }, 50); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-drawer-open-cart')) setTimeout(function () { loadRecs(true); }, 50);
    });
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(function () { if (drawerOpen()) loadRecs(false); })
        .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    refresh();
    if (onCartPage()) loadRecs(true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
